import React, {useCallback, useEffect} from 'react'
import View from './view'
import {useParams} from 'react-router-dom'
import {useAppDispatch} from '../../../redux/configureStore'
import {useAuth} from '../../../components/AuthProvider'
import {getStudyGuide, selectStudyGuide} from '../../../redux/studyGuides'
import {toggleErrorDialog} from '../../../redux/config'
import {useSelector} from 'react-redux'
import {clearExamState} from '../../../redux/exams'

const QuizPage = () => {
  const dispatch = useAppDispatch()
  const auth = useAuth()

  const {studyGuideId, quizId, studyDay} = useParams()

  const studyGuide = useSelector(selectStudyGuide)

  const clearQuiz = async () => {
    await dispatch(clearExamState())
  }

  const loadStudyGuide = useCallback(async () => {
    try {
      if (studyGuideId) {
        await dispatch(
          getStudyGuide({
            auth,
            studyGuideId,
            studyDay: Number(studyDay),
            keepState: true,
          }),
        )
      }
    } catch (e) {
      await dispatch(
        toggleErrorDialog({
          opened: true,
          error:
            'We were unable to load the quiz, please retry reloading the page. If issues persist contact our support team',
        }),
      )
    }
  }, [dispatch, studyGuideId, studyDay])

  useEffect(() => {
    loadStudyGuide()

    return () => {
      clearQuiz()
    }
  }, [loadStudyGuide, quizId])

  return <View studyGuide={studyGuide} studyDay={studyDay} quizId={quizId} />
}

export default QuizPage
